import fetch from './fetch'; 
import fetchAuth from './fetchAuth';
import { streamPost } from './streamFetch.js';
function transformRequest (data1,headers){
    //这个请求不需要请求头(在此处删除，上方设置的请求头。)  
    if(headers.Authorization||headers.common.Authorization){
        delete headers.Authorization;
        delete headers.common.Authorization;
    }
    return data1;
}
/*----首页-----*/ 
// 退出
export function logout (params = {}) {
    return fetchAuth.post(`/logout`,  params);
}
// 用户信息
export function login(params = {}) {
    return fetch.get(`/login`, { params,transformRequest:transformRequest });
}
// 用户信息
export function getUsetInfo(params = {}) {
    return fetch.get(`/info`, { params });
}
/*----首页 banner检索二级页面----*/ 
//普通检索
export function commonSearch(params = {}) {
    return fetch.post(`/search/commonSearch`, params);
}
//扣除积分
export function checkScoreStatus(params = {}) {
    return fetch.post(`/search/checkScoreStatus`, params);
}
//积分扣除状态
export function isDeductScore(params = {}) {
    return fetch.post(`/search/isDeductScore`, params);
}
//页面左侧目录
export function globalSearchTree(params = {}) {
    return fetch.post(`/search/globalSearch`, params);
}
//详情
export function globalInfo(params = {}) {
    return fetch.post(`/search/info`, params);
}
/*文献计量相关=============*/ 

//文献计量分页
export function bibliometricsPage(params = {}) {
    return fetch.post(`/bibliometrics/page`, params);
} 
//文献计量左侧列表
export function bibliometricsFace(params = {}) {
    return fetch.post(`/bibliometrics/face`, params);
}
//计量分析-获取高级检索全部ID
export function bibliometricsGetIdList(params = {}) {
    return fetch.post(`/bibliometrics/getIdList`, params);
}
//文献计量详情
export function bibliometricsInfo(id) {
    return fetch.get(`/bibliometrics/${id}`, );
}  
//计量分析-生成报告
export function bibliometricsGenerateReport(params = {}) {
    return fetch.post(`/bibliometrics-analysis-pool/generateReport`, params);
} 
//计量分析-分析池数据数量
export function getAnalysisPoolDataCount(params = {}) {
    return fetch.get(`/bibliometrics-analysis-pool/getAnalysisPoolDataCount`, {params});
} 
//计量分析-分析池详情
export function getAnalysisPoolData(id) {
    return fetch.get(`/bibliometrics-analysis-pool/getAnalysisPoolData/${id}`, );
} 
//计量分析-批量加入分析池数据 
export function bibliometricsAddAnalysisPool(params = {}) {
    return fetch.post(`/bibliometrics-analysis-pool/addAnalysisPool`, params);
} 
//批量删除分析池数据： 
export function bibliometricsDeleteAnalysisPoolData(params = {}) {
    return fetch.post(`/bibliometrics-analysis-pool/deleteAnalysisPoolData`, params);
} 
//一键清空分析池数据
export function removeAllAnalysisPoolData(params = {}) {
    return fetch.get(`/bibliometrics-analysis-pool/removeAllAnalysisPoolData`, {params});
} 
//分析池文献上传:
export function  bibliometricsUpload(params = {}) {
    return fetch.post(`/bibliometrics-analysis-pool/upload`, params);
}
//计量分析-全部数据加入分析池
export function bibliometricsAddAllAnalysisPool(params = {}) {
    return fetch.post(`/bibliometrics-analysis-pool/addAllAnalysisPool`, params);
}
//计量分析-分析池列表
export function analysisPage(params = {}) {
    return fetch.post(`/bibliometrics-analysis-pool/page`, params);
}
//计量分析图谱
export function analysisVisualization(id) {
    return fetch.get(`/bibliometrics-analysis-pool/analysisVisualization/${id}`,);
} 
//不同地区作者发文量
export function provinceCityStatistics(params) {
    return fetch.get(`/bibliometrics-analysis-pool/provinceCityStatistics`,{params});
} 
//计量分析关键词聚类K值
export function analysisClusterKeywords(params) {
    return fetch.get(`/bibliometrics-analysis-pool/analysisClusterKeywords`,{params} );
} 
/*知识应用模块相关=============*/ 
// 构建知识图谱
export function knowledgeGraph(params = {}) {
    return fetch.get(`/knowledge_graph/getGraph`, {params});
}
// 构建知识图谱导出
export function knowledgeGraphExport(params = {}) {
    return fetch.get(`/knowledge_graph_relation/export`, {params});
}
// 构建知识图谱列表
export function knowledgeGraphPage(params = {}) {
    return fetch.get(`/knowledge_graph_relation/page`,{params});
}
//方剂识别列表，flag-->use:经典  common:全部
export function getClassicList(params = {}) {
    return fetch.post(`/tcm_show_formula/getClassicList`, params);
} 
//智能养生问答API
export function getHealthAi(params = {}) {
    return fetch.post(`/ai/model/getHealth`, params);
} 
// AI问答API  (banner检索) - 流式输出版本
export function questionsAnswers(params = {}, onMessage, onError, onComplete) {
    return streamPost('/ai/model/questions_answers', params, onMessage, onError, onComplete);
} 
//AI问答API- 随机ID
export function getRandomId(params = {}) {
    return fetch.get(`/ai/model/getRandomId`, {params});
} 

/*----特色资源-----*/ 
//首页特色资源
export function resourceList(params = {}) {
    return fetch.get(`/resource/indexListInfo`,{params,transformRequest:transformRequest});
}
//特色资源查看更多
export function resourceMoreListInfo(params = {}) {
    return fetch.get(`/resource/moreListInfo`,{params});
}
//特色资源3级页面列表检索
export function resourceSearch(params = {}) {
    return fetch.post(`/search/resourceSearch`, params);
}
/*----热点新闻-----*/ 
//首页热点新闻列表
export function hotNewsList(params = {}) {
    return fetch.get(`/news/list`,{params});
}
//热点新闻详情
export function hotNewsDetails(id) {
    return fetch.get(`/news/detail/${id}`,);
}

/*----学古籍-----*/ 
//古籍列表
export function bookList(params = {}) {
    return fetch.post(`/study/guji/search/bookList`, params);
} 
//古籍左侧列表
export function bookFacetList(params = {}) {
    return fetch.post(`/study/guji/search/bookFacetList`, params);
}
//古籍目录树
export function bookCatalogTree(params = {}) {
    return fetch.get(`/study/guji/getCatalogTree`,{params});
}
//古籍信息
export function bookInfo(params = {}) {
    return fetch.get(`/study/guji/search/bookInfo`,{params});
}
//条目列表
export function entryList(params = {}) {
    return fetch.post(`/study/guji/search/entryList`, params);
}
//条目左侧列表
export function entryFacetList(params = {}) {
    return fetch.post(`/study/guji/search/entryFacetList`, params);
}
//条目信息
export function entryInfo(params = {}) {
    return fetch.post(`/study/guji/search/entryInfo`,params);
}
//学古籍二级页面否扣除积分
export function studyIsDeductScore(params = {}) {
    return fetch.post(`/study/guji/isDeductScore`, params);
}
//学古籍二级页面判断积分是否扣除-点击确认扣除积分提示后，真实扣除积分
export function studyCheckScoreStatus(params = {}) {
    return fetch.post(`/study/guji/checkScoreStatus`, params);
}
/*----学临床-----*/ 
//首页学临床,学中药列表
export function clinicList(params = {}) {
    return fetch.get(`/study/ccm/list`,{params});
}
//二级分页文章列表
export function secondList(params = {}) {
    return fetch.get(`/study/ccm/secondList`,{params});
}
/*----学题库-----*/ 
//首页学题库
export function topicList(params = {}) {
    return fetch.get(`/study/tiku/list`,{params});
}
//题库列表
export function questionList(params = {}) {
    return fetch.get(`/study/tiku/questionList`,{params});
}
//确认答案
export function confirmAnswer(params = {}) {
    return fetch.get(`/study/tiku/confirmAnswer`,{params});
}
//检索列表
export function searchListTK(params = {}) {
    return fetch.get(`/study/tiku/searchList`,{params});
}



